import {
    FETCH_GUESSS,
    FETCH_GUESSGOODS,
    FETCH_GUESSRANKINGLIST,
} from '../actions/guess';


export const initialState = {
    isFetching: true,
    data: null
};

export const guesss = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_GUESSS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_GUESSS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}
export const guessGoods = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_GUESSGOODS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_GUESSGOODS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}
export const guessRankings = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_GUESSRANKINGLIST}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_GUESSRANKINGLIST}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/redux/reducers/guess.js